import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Home } from 'lucide-react';

const SuccessPage = () => {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #000000 0%, #0a0a0a 50%, #000000 100%)',
      padding: '20px',
      fontFamily: 'Inter, sans-serif'
    }}>
      <div style={{
        textAlign: 'center',
        maxWidth: '700px',
        background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%)',
        padding: '80px 60px',
        borderRadius: '24px',
        border: '3px solid #D4AF37',
        boxShadow: '0 20px 60px rgba(212, 175, 55, 0.4)'
      }}>
        <CheckCircle size={100} color="#FFD700" style={{ marginBottom: '40px' }} />
        
        <h1 style={{
          fontFamily: 'Montserrat, sans-serif',
          background: 'linear-gradient(135deg, #FFFFFF 0%, #FFD700 50%, #D4AF37 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          fontSize: '48px',
          marginBottom: '24px',
          fontWeight: '800'
        }}>
          Solicitação Enviada!
        </h1>
        
        <p style={{
          color: 'rgba(255, 255, 255, 0.85)',
          fontSize: '18px',
          lineHeight: '1.7',
          marginBottom: '48px',
          fontWeight: '400'
        }}>
          Recebemos sua solicitação de doação com sucesso! ✨
          <br /><br />
          Nossa equipe da Viva Impact e WG analisará seu pedido e entrará em contato em breve através do email ou telefone fornecido.
          <br /><br />
          💙 Obrigado por acreditar no nosso trabalho!
        </p>
        
        <Link 
          to="/"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '12px',
            padding: '18px 48px',
            background: 'linear-gradient(135deg, #FFD700 0%, #D4AF37 100%)',
            color: '#000',
            textDecoration: 'none',
            borderRadius: '16px',
            fontSize: '18px',
            fontWeight: '800',
            fontFamily: 'Montserrat, sans-serif',
            border: '2px solid #FFD700',
            boxShadow: '0 12px 40px rgba(212, 175, 55, 0.4)',
            transition: 'all 0.3s ease',
            textTransform: 'uppercase',
            letterSpacing: '1px'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-4px)';
            e.target.style.boxShadow = '0 20px 60px rgba(212, 175, 55, 0.6)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 12px 40px rgba(212, 175, 55, 0.4)';
          }}
        >
          <Home size={20} />
          Voltar para Home
        </Link>
      </div>
    </div>
  );
};

export default SuccessPage;
